// 自定義 Markdown Serializer
// 將 Tiptap 的 JSON 結構轉換為 Markdown，不做任何不必要的轉義

export function serializeToMarkdown(doc) {
  return serializeNode(doc)
}

function serializeNode(node, marks = []) {
  if (!node) return ''

  // 處理文本節點
  if (node.type === 'text') {
    let text = node.text || ''

    // 套用 marks（粗體、斜體等）
    if (node.marks && node.marks.length > 0) {
      node.marks.forEach(mark => {
        switch (mark.type) {
          case 'bold':
            text = `**${text}**`
            break
          case 'italic':
            text = `*${text}*`
            break
          case 'code':
            text = `\`${text}\``
            break
          case 'strike':
            text = `~~${text}~~`
            break
          case 'link':
            text = `[${text}](${mark.attrs?.href || ''})`
            break
        }
      })
    }

    return text
  }

  // 處理其他節點類型
  switch (node.type) {
    case 'doc':
      return node.content?.map(n => serializeNode(n)).join('\n\n') || ''

    case 'paragraph':
      return node.content?.map(n => serializeNode(n)).join('') || ''

    case 'heading':
      const level = node.attrs?.level || 1
      const heading = '#'.repeat(level)
      const text = node.content?.map(n => serializeNode(n)).join('') || ''
      return `${heading} ${text}`

    case 'bulletList':
      return node.content?.map(n => serializeBulletListItem(n)).join('\n') || ''

    case 'orderedList':
      return node.content?.map((n, i) => serializeOrderedListItem(n, i + 1)).join('\n') || ''

    case 'taskList':
      return node.content?.map(n => serializeTaskItem(n)).join('\n') || ''

    case 'listItem':
      return node.content?.map(n => serializeNode(n)).join('') || ''

    case 'taskItem':
      const checked = node.attrs?.checked || false
      const checkbox = checked ? '[x]' : '[ ]'
      const content = node.content?.map(n => serializeNode(n)).join('') || ''
      return `${checkbox} ${content}`

    case 'codeBlock':
      const code = node.content?.map(n => n.text || '').join('\n') || ''
      return `\`\`\`\n${code}\n\`\`\``

    case 'blockquote':
      const quoteContent = node.content?.map(n => serializeNode(n)).join('\n') || ''
      return quoteContent.split('\n').map(line => `> ${line}`).join('\n')

    case 'horizontalRule':
      return '---'

    case 'hardBreak':
      return '\n'

    default:
      // 未知節點類型，嘗試處理其內容
      if (node.content) {
        return node.content.map(n => serializeNode(n)).join('')
      }
      return ''
  }
}

function serializeBulletListItem(node) {
  const content = node.content?.map(n => serializeNode(n)).join('') || ''
  return `- ${content}`
}

function serializeOrderedListItem(node, index) {
  const content = node.content?.map(n => serializeNode(n)).join('') || ''
  return `${index}. ${content}`
}

function serializeTaskItem(node) {
  const checked = node.attrs?.checked || false
  const checkbox = checked ? '[x]' : '[ ]'
  const content = node.content?.map(n => serializeNode(n)).join('') || ''
  return `${checkbox} ${content}`
}
